export const ViewVoteIconsConstants = {
  chatBubble: {
    iconName: 'chat_bubble',
    colorClass: 'text-darkBlue-600',
  },
  draft: {
    iconName: 'draft',
    colorClass: 'text-blue-500',
  },
  howToVote: {
    iconName: 'how_to_vote',
    colorClass: 'text-grey-800',
  },
  history: {
    iconName: 'history',
    colorClass: 'text-grey-800',
  },
  quickReference: {
    iconName: 'quick_reference',
    colorClass: 'text-grey-800',
  }
};
